export const pageLanguageLinks = Object.freeze({
  "home": {
    "de": "/de",
    "fr": "/fr",
    "en": "/en"
  },
  "webform-route": {
    "de": {
      "name": "webform-route"
    },
    "fr": {
      "name": "webform-route"
    },
    "en": {
      "name": "webform-route"
    }
  },
  "search": {
    "de": "/de/suche",
    "fr": "/fr/recherche",
    "en": "/en/search"
  },
  "landing-page-ch": {
    "de": "/de/schweiz",
    "fr": "/fr/suisse",
    "en": "/en/switzerland"
  },
  "landing-page-de": {
    "de": "/de/deutschland",
    "fr": "/fr/allemagne",
    "en": "/en/germany"
  },
  "node-canonical": {
    "de": {
      "name": "node-canonical"
    },
    "fr": {
      "name": "node-canonical"
    },
    "en": {
      "name": "node-canonical"
    }
  },
  "landing-page-group": {
    "de": "/de/gruppe",
    "fr": "/fr/groupe",
    "en": "/en/group"
  },
  "landing-page-hotel": {
    "de": "/de/hotel",
    "fr": "/fr/hotel",
    "en": "/en/hotel"
  },
  "webform-confirmation": {
    "de": {
      "name": "webform-confirmation"
    },
    "fr": {
      "name": "webform-confirmation"
    },
    "en": {
      "name": "webform-confirmation"
    }
  },
  "press-release-detail": {
    "de": {
      "name": "press-release-detail___de"
    },
    "fr": {
      "name": "press-release-detail___fr"
    },
    "en": {
      "name": "press-release-detail___en"
    }
  }
});
export const routeNamesWithoutMapping = Object.freeze(["home","webform-route","drupal-route","node-canonical","webform-confirmation"]);
export const routeNamesWithLanguageParam = Object.freeze(["home","webform-route","node-canonical","webform-confirmation"]);